import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5874f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 「毎月抽選で50名様に当たる！ジョーズ・タウン ログインキャンペーン」抽選企画について")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ※初回ログインの方 ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("ログインキャンペーン」抽選企画について")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "＜参加条件＞", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " ジョーズ・タウン会員が、初めてジョーズ・タウンにログインした時に抽選に応募できます。 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " 日本国内にお住まいで、かつ賞品のお届け先が日本国内の方に限ります。 ", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " ジョーズ・タウン会員が、ジョーズ・タウンにログインすると、毎月１回抽選に応募できます。 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " 日本国内にお住まいで、かつ賞品のお届け先が日本国内の方に限ります。 ", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "＜当選賞品＞", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "抽選で毎月50名様にアマゾンギフト券1,000円分をプレゼント。", -1))
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<h2 data-v-6c5874f4>＜注意事項＞</h2><ul data-v-6c5874f4><li data-v-6c5874f4>本キャンペーンは株式会社一条工務店が企画・主催しております。</li><li data-v-6c5874f4> 本キャンペーンの賞品をインターネットオークションやフリマアプリ等で販売することは止めていただきますようお願いいたします。転売行為が確認された場合、本キャンペーンを含めた賞品企画の中止、転売行為者の会員アカウントの削除等の措置を講じざるを得なくなる可能性があります。また、転売・譲渡された賞品に関して当社は一切責任を負いません。 </li><li data-v-6c5874f4> 当社は、本キャンペーンに関連して会員に生じた損害について、当社の故意または重大な過失がない限り、一切の責任を負わないものとします。 </li><li data-v-6c5874f4> 当社は、本キャンペーンに関連して生じた応募者間または応募者と第三者の間におけるトラブルについて一切の責任を負わないものとします。 </li><li data-v-6c5874f4> 本キャンペーンの応募に係るインターネット通信料、接続料は、会員のご負担となります。 </li><li data-v-6c5874f4> 応募フォームを他者に共有または、譲渡する等、当社が不適正な行為と判断した場合は、当選を無効とします。 </li><li data-v-6c5874f4> 当選者の住所・転居先が不明、長期不在などの事情により賞品がお届けできない場合は、当選を無効とします。 </li><li data-v-6c5874f4> 本キャンペーンの内容・応募規約は予告なく終了となる場合があります。 </li></ul><h2 data-v-6c5874f4>＜禁止事項＞</h2><ul data-v-6c5874f4><li data-v-6c5874f4>賞品の転売行為</li><li data-v-6c5874f4>本キャンペーンの運営を妨げる行為</li><li data-v-6c5874f4>本規約に違反する行為</li><li data-v-6c5874f4>他人に迷惑、不利益、損害、または不快感を与える行為</li><li data-v-6c5874f4>当社が悪質または不適切であると判断する行為</li></ul><h2 data-v-6c5874f4>＜お問い合わせ＞</h2><p data-v-6c5874f4>一条工務店ジョーズ・タウン事務局</p><p data-v-6c5874f4> メールアドレス：<a href=\"mailto:joestown@ichijo.co.jp\" data-v-6c5874f4>joestown@ichijo.co.jp</a></p><p data-v-6c5874f4> ※お問い合せの内容によっては、回答までにお時間がかかる場合や、回答を差し上げられない場合がございます。ご了承ください。 </p>", 8)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "accordion",
    class: _normalizeClass([{ forceOpen: _ctx.forceOpen }, "accordion"])
  }, [
    _createElementVNode("div", {
      class: "header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args)))
    }, "応募要項"),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isNewMember)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_6))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createTextVNode(" 「毎月抽選で" + _toDisplayString(_ctx.total) + "名様に当たる！ジョーズ・タウン", 1),
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
          ])),
      _hoisted_11,
      (_ctx.isNewMember)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_15))
        : (_openBlock(), _createElementBlock("ul", _hoisted_16, _hoisted_19)),
      (_ctx.isNewMember)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _hoisted_20,
            _hoisted_21
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_22
    ])
  ], 2))
}